// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-dots_loading__ZaSF5","spacer":"loading-dots_spacer__tzeIv","blink":"loading-dots_blink__H95l6"};